import { useMemo } from 'react';
import { VStack } from '@cbhq/cds-web/layout/VStack';

import { useClientProps } from '../providers/ClientPropsProvider';
import { useProfileMenuV2 } from '../providers/ProfileMenuV2Provider';
import { MenuActionItem } from '../types';

import { useCustomMenuActions } from './CustomMenuActions';
import { DarkModeActionItem } from './DarkModeActionItem';
import { ProfileMenuActionItem } from './ProfileMenuActionItem';

export function ProfileMenuActions(): JSX.Element {
  const { actions } = useProfileMenuV2();
  const { onThemeToggle } = useClientProps();

  const customMenuActions = useCustomMenuActions();

  const memoizedActions = useMemo(() => {
    const menuActions = actions?.map((apiAction: MenuActionItem) => {
      return <ProfileMenuActionItem key={apiAction.key} apiAction={apiAction} />;
    });

    const lastIndex = menuActions.length - 1;

    if (onThemeToggle) {
      menuActions.splice(
        lastIndex,
        0,
        ...customMenuActions,
        <DarkModeActionItem key="theme-toggle" />,
      );
    }

    return menuActions;
  }, [actions, customMenuActions, onThemeToggle]);

  const paddingBottom = useMemo(() => {
    return {
      phone: 2 as const,
      tablet: 0 as const,
      desktop: 0 as const,
    };
  }, []);

  return <VStack paddingBottom={paddingBottom}>{memoizedActions}</VStack>;
}
